import React from 'react';
import s from './FormTitle.module.scss';

export default function FormTitle({ children }) {
    return <h3 className={s.title}>{children}</h3>;
}
